import { cn } from "@workspace/ui";

import type { Icon } from "@workspace/ui/components/icons";

export const Section = ({
  className,
  ...props
}: React.ComponentProps<"section">) => (
  <section
    className={cn(
      "col-[2] grid scroll-mt-4 grid-cols-1 justify-items-center gap-y-10 py-16 sm:gap-y-12 md:gap-y-14 md:py-24 lg:gap-y-16 lg:py-28",
      className,
    )}
    {...props}
  />
);

export const SectionHeader = ({
  className,
  ...props
}: React.ComponentProps<"header">) => (
  <header
    className={cn(
      "flex flex-col items-center justify-center gap-6 sm:gap-8 md:gap-10 lg:gap-12",
      className,
    )}
    {...props}
  />
);

export const SectionHeading = ({
  className,
  ...props
}: React.ComponentProps<"div">) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center gap-4 md:gap-6",
      className,
    )}
    {...props}
  />
);

export const SectionHeadingTitle = ({
  className,
  children,
  ...props
}: React.ComponentProps<"h2">) => (
  <h2
    className={cn(
      "max-w-5xl px-2 text-center text-4xl font-medium tracking-tight text-balance sm:text-5xl md:text-6xl",
      className,
    )}
    {...props}
  >
    {children}
  </h2>
);

export const SectionHeadingDescription = ({
  className,
  ...props
}: React.ComponentProps<"p">) => (
  <p
    className={cn(
      "text-muted-foreground max-w-3xl px-2 text-center text-pretty md:text-lg",
      className,
    )}
    {...props}
  />
);

interface SectionHeadingBadgeProps {
  readonly icon: Icon;
  readonly text: string;
}

export const SectionHeadingBadge = ({
  icon: Icon,
  text,
}: SectionHeadingBadgeProps) => (
  <div className="bg-card text-foreground/90 relative flex items-center justify-center gap-2 rounded-xl border px-3 py-1.5 shadow-xs">
    <Icon className="size-5" />
    <span className="text-sm font-medium">{text}</span>
  </div>
);
